import { clsx, styx } from "modules/Utils";
import { CSSProperties } from "react";

interface TabSymphonyProps {
    className: string;
    style?: CSSProperties;
    visible: boolean;
    children?: React.ReactNode;
}

const TabSymphony = ({
    className,
    style,
    children,
    visible = false
}: TabSymphonyProps) => {
    return (
        <div
            className={clsx('tabSymphonyElement', className)}
            style={styx(
                sty.tabSymphonyElement,
                style,
                visible ? sty.visible : sty.hidden
            )}
        >
            {children}
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    tabSymphonyElement: {
        width: '100%',
        flexDirection: 'column',
    },
    visible: {
        display: 'flex'
    },
    hidden: {
        display: 'none'
    }
}

export default TabSymphony;